// eslint-disable-next-line import/no-unresolved
import React, {Fragment} from 'react';
// eslint-disable-next-line import/no-unresolved
import axios from 'axios';

import translations from '../../../constants/translations';
import promotionP from "../../../factories/widgets/mapping/promotion";
import Promotions from '.';
import { promotion } from "../../../factories/widgets/mapping/promotion";


/* eslint-disable */
/**
 * Header Provider HOC
 */
class PromotionProvider extends React.Component {
  constructor(){
    super();
    this.state = {
      loaded: false,
      promotion: false
    }
  }

  componentDidMount() {
    axios.get(`${process.env.GATSBY_DYNAMIC_CONTENT}/promotions?id=${this.props.promotionId}`).then((data)=>{
      if (data.data && Array.isArray(data.data) && data.data.length > 0) {
        console.log(data.data);
        data.data[0].items = data.data[0].promotionitems;
        this.setState({
          promotion: promotion(data.data[0], this.props.locale),
          loaded: true
        });
      } else {
        this.setState({
          loaded: true
        })
      }
    })
  }

  render() {
    const {loaded, promotion} = this.state;

    if (!loaded || !promotion) {
      return <Fragment></Fragment>
    }
    console.log(promotion)
    return <Promotions {...promotion} />

  }
}
export default PromotionProvider;
